module.exports = __webpack_public_path__ + "media/mail/email-92f2e633.png";